<!-- Omni Components will get loaded here -->
<ng-container *cignaFeatureToggle="'generalChat'">
  <!-- <cigna-omni-interceptions-data></cigna-omni-interceptions-data> -->
  <cigna-omni-chat-shell></cigna-omni-chat-shell>
  <cigna-omni-chat-bubble-data
    [shouldEnablePreChatWelcome]="hasPrechatWelcomeFeature$ | async"
    [isUseRightNowChat]="useRightNowChat$ | async"
    [isLiveClinicianChat]="liveClinicianChat$ | async"
    [isLiveSupportChat]="liveSupportChat$ | async"
    [isPersonalGuideChat]="personalGuideChat$ | async"
    [isLiveChatAvailable]="liveChatAvailable$ | async"
    [isConsumerChatEnabled]="consumerSpecificChat$ | async"
  ></cigna-omni-chat-bubble-data>
  <cigna-omni-fancy-invitation-data></cigna-omni-fancy-invitation-data>
</ng-container>
